export default __webpack_public_path__ + "static/media/7.819e66d6.mp3";